export default {
  name: 'maintenance',
  data () {
    return {
      labelPosition: 'right',
      page: {
        num: 1,
        sizeSmall: 10,
        size: 100
      },
      tooltip: true,
      totalRows: 100,
      tableList: [],
      sysData: [],
      contractDialog: false,
      innerVisible: false,
      headers: {
        mtk: localStorage.getItem('usermtk')
      },
      uploadFile: this.$API.fileUpload,
      addContractInfo: {
        contractFiles: [],
        numberContract: '',
        nameContract: '',
        paymentName: '',
        createTime: '',
        contractBalance: '',
        superContractor: '',
        paymentAmount: '',
        companyContractor: ''
      },
      addContractInfoRule: {
        numberContract: [
          {
            required: true,
            message: '请输入合同编号',
            trigger: ['blur', 'change']
          }
        ],
        nameContract: [
          {
            required: true,
            message: '请输入合同名称',
            trigger: ['blur', 'change']
          }
        ],
        contractBalance: [
          {
            validator: (rule, value, callback) => {
              if (value !== '') {
                if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) === false) {
                  callback(new Error('请填写大于0的数字'))
                } else if ((/^[0-9]+(.[0-9]{1,2})?$/).test(value) === false) {
                  callback(new Error('请输入有效金额且小数点后面保留二位'))
                } else {
                  callback()
                }
              } else {
                callback(new Error('请填写大于0的数字'))
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        paymentAmount: [
          {
            validator: (rule, value, callback) => {
              if (value !== '') {
                if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) === false) {
                  callback(new Error('请填写大于0的数字'))
                } else if ((/^[0-9]+(.[0-9]{1,2})?$/).test(value) === false) {
                  callback(new Error('请输入有效金额且小数点后面保留二位'))
                } else {
                  callback()
                }
              } else {
                callback(new Error('请填写大于0的数字'))
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        paymentName: [
          {
            required: true,
            message: '请输入打款名称',
            trigger: ['blur', 'change']
          }
        ]
      },
      contractInfo: {
        supName: '',
        supShortName: '',
        supNumber: '',
        sysName: '',
        sysId: ''
      },
      resultList: [
        {
          contractId: '',
          contractCode: '',
          contractName: '',
          contractAmount: '',
          contractStartTime: '',
          contractEndTime: ''
        },
        {
          contractId: '',
          contractCode: '',
          contractName: '',
          contractAmount: '',
          contractStartTime: '',
          contractEndTime: ''
        },
        {
          contractId: '',
          contractCode: '',
          contractName: '',
          contractAmount: '',
          contractStartTime: '',
          contractEndTime: ''
        },
        {
          contractId: '',
          contractCode: '',
          contractName: '',
          contractAmount: '',
          contractStartTime: '',
          contractEndTime: ''
        }
      ],
      transferInfo: {
        person: '',
        primary: ''
      },
      transferDialog: false,
      rules: {
        person: [
          {
            required: true,
            message: '请变更责任人',
            trigger: ['blur', 'change']
          }
        ],
        primary: [
          {
            required: true,
            message: '请选择原责任人',
            trigger: ['blur', 'change']
          }
        ]
      },
      abuNameData: [],
      formInline: {
        sysId: '',
        supName: '',
        state: '',
        createTime: ''
      },
      stateData: [
        {
          id: 0,
          value: '停用'
        },
        {
          id: 1,
          value: '启用'
        }
      ],
      supArr: []
    }
  },
  activated () {
    this.queryList()
  },
  mounted () {
    this.querySearchSel()
    if (this.$route.query.num) {
      this.page.num = Number(this.$route.query.num)
      this.page.size = Number(this.$route.query.size)
      this.page.sizeSmall = Number(this.$route.query.size)
    }
    this.page = Object.assign({}, this.page)
    this.queryList()
    /* 查询商务经理列表 */
    let type = {abuType: 1}
    let _this = this
    this.$axios
      .get(this.$API.supplier.queryBusinessMangerList, {params: type})
      .then(function(r) {
        _this.abuNameData = r.data.resData.userList
      })
      .catch(function(error) {})
  },
  methods: {
    /* 表格状态值转换 */
    maintenanceStatus (row) {
      if (row.state == '0') {
        return '停用'
      } else if (row.state == '1') {
        return '启用'
      } else {
        return ''
      }
    },
    // 表格合同日期根据状态值设置颜色
    cellStyle (row, column, rowIndex, columnIndex) {
      if (row.column.label === '合同有效期') {
        if (row.row.expired === '0') {
          return ''
        } else if (row.row.expired === '2') {
          return 'color: orange'
        } else {
          return 'color: red'
        }
      }
    },
    querySearchSel () {
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size
      }
      let _self = this
      /* 查询所属系统列表 */
      this.$axios
        .post(this.$API.apiList.querySysList, params)
        .then(function (r) {
          _self.sysData = r.data.resData
        })
        .catch(function (error) {})
    },
    transfer () { //  商务转移
      this.transferDialog = true
    },
    closeTransfer () {
      this.transferInfo.person = ''
      this.transferInfo.primary = ''
      this.$refs['transferInfo'].resetFields()
    },
    transferSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.hisAbuId = _this.transferInfo.primary
          op.nowAbuId = _this.transferInfo.person
          _this.$axios({
            url: _this.$API.supplier.replaceSupAbuInfo,
            method: 'post',
            data: op
          }).then((response) => {
            _this.queryList()
            _this.$message.success('转移成功!')
            this.fileList = []
            _this.transferDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    queryList () {
      /* 查询列表 */
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.sizeSmall,
        sysIds: sysIds,
        supName: this.formInline.supName.trim(),
        state: this.formInline.state,
        createTimeStart: this.formInline.createTime
          ? this.formInline.createTime[0] + ' 00:00:00'
          : '',
        createTimeEnd: this.formInline.createTime
          ? this.formInline.createTime[1] + ' 23:59:59'
          : ''
      }
      let _self = this
      this.$axios
        .post(this.$API.supplier.getSupInfoListByPage, params)
        .then(function (r) {
          _self.tableList = r.data.resData.rows
          _self.totalRows = r.data.resData.total
        })
        .catch(function (error) {})
    },
    /* checkbox 选中时获取供应商id */
    handleSelectionChange (val) {
      this.supArr = []
      if (val.length) {
        for (let v of val) {
          this.supArr.push(v.supId)
        }
      }
    },
    informationContract (index, val) {
      let _this = this
      let params = {}
      params.supId = val.supId
      params.sysIds = []
      params.contractId = ''
      params.startTime = ''
      params.pageSize = 100
      params.pageNum = 1
      this.$axios
        .post(this.$API.billmanagement.querySupContractListByPage, params)
        .then(function (r) {
          let data = r.data.resData
          console.log(data)
          _this.contractInfo.supName = val.supName
          _this.contractInfo.supShortName = val.supShortName
          _this.contractInfo.supNumber = val.supId
          _this.contractInfo.sysName = val.sysName
          _this.contractInfo.sysId = val.sysId
          _this.resultList = data.resultList
        })
        .catch(function (error) {})
      this.contractDialog = true
    },
    addContractInfoSave (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          let id = _this.contractInfo.sysId
          let sysIds = []
          if (id && id !== 0) {
            sysIds.push(id)
          }
          op.sysIds = sysIds
          op.supId = _this.contractInfo.supNumber
          op.contractCode = _this.addContractInfo.numberContract
          op.contractName = _this.addContractInfo.nameContract
          op.transferName = _this.addContractInfo.paymentName
          op.contractStartTime = _this.addContractInfo.createTime ? _this.addContractInfo.createTime[0] : ''
          op.contractEndTime = _this.addContractInfo.createTime ? _this.addContractInfo.createTime[1] : ''
          let contractFiles = []
          for (let v of this.addContractInfo.contractFiles) {
            let o = {}
            o.contractFileName = v.name
            o.contractFileUrl = v.url
            contractFiles.push(o)
          }
          op.contractFiles = contractFiles
          op.contractAmount = _this.addContractInfo.contractBalance
          op.transferAmount = _this.addContractInfo.paymentAmount
          op.abuName = _this.addContractInfo.companyContractor
          op.supAbuName = _this.addContractInfo.superContractor
          _this.$axios
            .post(_this.$API.billmanagement.addSupContract, op)
            .then(function (r) {
              let params = {}
              params.supId = _this.contractInfo.supNumber
              params.sysIds = []
              params.contractId = ''
              params.startTime = ''
              params.pageSize = 100
              params.pageNum = 1
              _this.$axios
                .post(_this.$API.billmanagement.querySupContractListByPage, params)
                .then(function (r) {
                  let data = r.data.resData
                  _this.resultList = data.resultList
                })
                .catch(function (error) {})
              _this.innerVisible = false
              _this.$message({
                type: 'success',
                message: '新增供应商合同成功'
              })
            })
            .catch(function (error) { console.log(error) })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    closeContract () {
      this.contractInfo = {
        supName: '',
        supShortName: '',
        supNumber: '',
        sysName: '',
        sysId: ''
      }
    },
    closeAddContractInfo () {
      this.addContractInfo = {
        contractFiles: [],
        numberContract: '',
        nameContract: '',
        paymentName: '',
        createTime: '',
        contractBalance: '',
        superContractor: '',
        paymentAmount: '',
        companyContractor: ''
      }
      this.$refs['addContractInfo'].resetFields() // 关闭时清除验证条件
    },
    /* 批量删除 */
    handleDel () {
      if (!this.supArr.length) {
        this.$message.warning('请选择供应商档案!')
        return
      }
      let params = {
        ids: this.supArr
      }
      this.$confirm('确认删除此供应商档案?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let _self = this
          this.$axios
            .post(this.$API.supplier.deleteSupInfoById, params)
            .then(function (r) {
              _self.$message({
                type: 'success',
                message: '删除成功'
              })
              _self.queryList()
            })
            .catch(function (error) {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    /* 新增跳转路由 */
    handleAdd () {
      this.$router.push({
        path: '/addMaintenance',
        query: {
          num: this.page.num,
          size: this.page.sizeSmall
        }
      })
    },
    /* 编辑 */
    handleEdit (index, value) {
      this.$router.push({
        path: '/editMaintenance',
        query: {
          supId: value.supId,
          num: this.page.num,
          size: this.page.sizeSmall
        }
      })
    },
    /* 切换状态 启用/禁用 */
    changeStatus (index, value) {
      if (value.state == 1) {
        value.state = 0
        let params = {
          supId: value.supId,
          state: 1
        }
        this.$confirm('确认是否修改供应商状态为启用?', '启用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(this.$API.supplier.changeSupState, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '启用成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      } else {
        value.state = 1
        let params = {
          supId: value.supId,
          state: 0
        }
        this.$confirm('确认是否修改供应商状态为停用?', '停用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(this.$API.supplier.changeSupState, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '停用成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      }
    },
    /* 跳转详情页 */
    detail (index, row) {
      this.$router.push({
        path: '/maintenanceDetails',
        query: {
          supId: row.supId,
          sysId: row.sysId,
          num: this.page.num,
          size: this.page.sizeSmall
        }
      })
    },
    /* 点击查询按钮 */
    onSearch () {
      this.page.num = 1
      this.queryList()
    },
    /* 重置操作 */
    onReset (formName) {
      this.formInline = {
        sysId: '',
        supName: '',
        state: '',
        createTime: ''
      }
      this.$refs[formName].resetFields()
    },
    success(response, file, fileList) {
      if (!response.resCode) {
        this.$router.push('/login')
      }
      if (response.resData.url) {
        console.log(response.resData)
        let op = {}
        op.name = response.resData.fileName
        op.url = response.resData.url
        this.addContractInfo.contractFiles.push(op)
      }
    },
    handleRemove(file, fileList) {
      // 删除图片
      let url = file.url
      for (let i = 0; i < this.addContractInfo.contractFiles.length; i++) {
        if (this.addContractInfo.contractFiles[i].url === url) {
          this.addContractInfo.contractFiles.splice(i, 1)
        }
      }
    },
    /* 点击文件列表中已上传的文件时的钩子 */
    handlePreview(file) {
      /* 预览 TODO */
      console.log(file)
      let _width = window.outerWidth
      let _height = window.outerHeight
      window.open(
        file.url,
        '_blank',
        'width=' +
          _width +
          ', height = ' +
          _height +
          ', menubar = no,toolbar = no, status = no, scrollbars = yes'
      )
      // const userAgent = navigator.userAgent
      // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      //   alert('推荐谷歌进行文件预览')
      // } else {
      //   window.open(file.url) // blob格式地址
      // }
    },
    /* 上传前校验大小限制 */
    beforeAvatarUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf'
      const isLt2M = file.size / 1024 / 1024 < 20
      /* if(!extension) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        });
      } */
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 20MB!',
          type: 'warning'
        })
      }
      return extension && isLt2M
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.sizeSmall = val
      this.page.num = 1
      this.queryList()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.queryList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/supper/maintenance.js